const shareList = (url, media, pinterestMedia) => [
  {
    name: 'Twitter',
    modalProps: {
      url,
    },
    iconProps: {
      iconBgStyle: {
        fill: 'white',
      },
      logoFillColor: 'grey',
    },
    additionalProps: {
      'aria-label': 'Twitter Button',
    },
  },
  {
    name: 'Facebook',
    modalProps: {
      url,
    },
    iconProps: {
      iconBgStyle: {
        fill: 'white',
      },
      logoFillColor: 'grey',
    },
    additionalProps: {
      'aria-label': 'Facebook Button',
    },
  },
  {
    name: 'Linkedin',
    modalProps: {
      url,
    },
    iconProps: {
      iconBgStyle: {
        fill: 'white',
      },
      logoFillColor: 'grey',
    },
    additionalProps: {
      'aria-label': 'Linkedin Button',
    },
  },
  {
    name: 'Pinterest',
    modalProps: {
      url,
      media: pinterestMedia,
    },
    iconProps: {
      iconBgStyle: {
        fill: 'white',
      },
      logoFillColor: 'grey',
    },
    additionalProps: {
      'aria-label': 'Pinterest Button',
    },
  },
];

export default shareList;
